<template>
  <canvas
    :id="id"
  />
</template>

<script>
import Chart from 'chart.js/auto'

export default {
  name: 'BaseComparaisonBarChart',
  props: {
    chartData: {
      type: Object,
      default: () => { }
    },
    id: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      chart: null,
      options: {
        responsive: true,
        aspectRatio: 1.5,
        scales: {
          y: {
            display: false
          },
          x: {
            grid: {
              display: false,
              borderColor: 'transparent'
            },
          }
        },
        animations: { duration: 0 },
        plugins: {
          datalabels: {
            formatter: function (value) {
              return value> 0 ? `${Math.round(value, 0)}%` : null
            },
            color: function (ctx) {
              return ctx.dataIndex === ctx.dataset.indexAdherent ? 'white' : 'rgba(0, 110, 51)'
            },
            font: {
              weight: '700'
            }
          },
          legend: {
            display: false
          },
          tooltip: {
            mode: 'nearest',
            intersect: false,
            callbacks: {
              title: () => {
                return ''
              },

              // eslint-disable-next-line no-unused-vars
              label: (context) => {
                const moyenneStr = Number.parseFloat(context.dataset.moyenneAdherent).toString().replace(/\./g, ',')
                return 'Mon exploitation : ' + moyenneStr
              }
            },
            // Désactive le carré de couleur dans le tooltip
            custom: function (tooltip) {
              tooltip.displayColors = false
            },
            // Désactive le tooltip en rajoutant 'tooltipDisabled = true' dans le dataset
            filter: (tooltipItem) => {
              return tooltipItem.dataIndex === this.chartData.datasets[0].indexAdherent
            }
          }
        }
      }
    }
  },

  watch: {
    chartData: {
      handler () {
        this.chart.data = this.chartData
        this.chart.update()
      }
    }
  },
  mounted () {
    const config = {
      options: this.options,
      data: this.chartData
    }
    this.chart = new Chart(document.getElementById(this.id), config)
  }
}
</script>
